import "@fontsource-variable/inter/opsz.css";
import "@fontsource-variable/geist-mono/wght.css";
import "./styles/tokens.css";
import "./styles/base.css";
import "./styles/ui.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router";
import { Layout } from "./components/Layout";
import { Loading } from "./components/States";
import { HomePage } from "./pages/HomePage";
import { RunPage } from "./pages/RunPage";
import { RunsPage } from "./pages/RunsPage";
import { NotFoundPage, PageError } from "./pages/SimplePages";

// The wallet and chain pages load their code (wagmi, viem) only when opened.
const router = createBrowserRouter([
  {
    element: <Layout />,
    // Shown while a lazy page loads on a direct visit (before the layout can render).
    hydrateFallbackElement: <Loading label="Loading…" />,
    errorElement: <PageError />,
    children: [
      {
        // Inside the layout, so that a failing page keeps the header and the footer.
        errorElement: <PageError />,
        children: [
      { path: "/", element: <HomePage /> },
      { path: "/runs", element: <RunsPage /> },
      { path: "/run/:runId", element: <RunPage /> },
      { path: "/new", lazy: () => import("./pages/NewRunPage").then((m) => ({ Component: m.NewRunPage })) },
      { path: "/oracle", lazy: () => import("./pages/OraclePage").then((m) => ({ Component: m.OraclePage })) },
      { path: "/admin", lazy: () => import("./pages/AdminPage").then((m) => ({ Component: m.AdminPage })) },
      { path: "*", element: <NotFoundPage /> },
        ],
      },
    ],
  },
]);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
